export default "__VITE_ASSET__e1aac3fb__"